module.exports = __webpack_public_path__ + "img/pic_gxa4gbpkit@2x.dfdb9439.png";